import { FC } from 'react';

type DocumentListLoaderProps = {
  rows: number;
  height?: number; // optional height in px
};

const DocumentListLoader: FC<DocumentListLoaderProps> = ({ rows, height }) => (
  <div className="card-inner w-100">
    <div className="placeholder-glow text-left">
      {Array.from({ length: rows }).map((_, index) => (
        <div
          // eslint-disable-next-line react/no-array-index-key
          key={`document-list-row-${index}`}
          className={`placeholder col-12 mb-3 ${!height ? 'h-25px' : ''}`}
          style={height ? { height: `${height}px` } : undefined}
        />
      ))}
    </div>
  </div>
);

export default DocumentListLoader;
